<template>
  <!--编辑类 弹出框-->
  <div class="dialog-body">
    <div class="dialog-title">
      <h4>{{ title }}</h4>
    </div>
    <div style="position: relative">
      <div class="search-template">
        <el-input
          type="text"
          v-model.trim="directory.keyword"
          :placeholder="
            activeName === 'folder'
              ? '请输入名称查询文件夹'
              : '请输入名称查询模板'
          "
          @keyup.enter.native="handleClick"
        >
          <i
            slot="suffix"
            @click="handleClick(false)"
            :class="
              !directory.keyword
                ? 'el-input__icon el-icon-search'
                : 'el-input__icon el-icon-close'
            "
          ></i>
        </el-input>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick(false)">
        <el-tab-pane
          v-for="item in tabNav"
          :label="item.name"
          :name="item.activeName"
          :key="item.actionName"
        >
          <div class="dt-content">
            <div class="bread" v-if="activeName === 'folder'">
              <ul>
                <li
                  class="purple-active second-title-li"
                  @click.stop="goDetail(0)"
                >
                  <span class="bread-text" data-id="0">全部</span>
                  <span
                    class="iconfont icon-Unfold-selected1"
                    v-if="breadList.length"
                  ></span>
                </li>

                <li
                  class="second-title-li"
                  :class="[
                    index !== breadList.length - 1 ? 'purple-active' : '',
                  ]"
                  v-for="(bread, index) in breadList"
                  :key="bread.id"
                  @click.stop="goDetail(bread)"
                >
                  <span class="bread-text" :data-id="bread.id">{{
                    bread.name
                  }}</span>
                  <span
                    v-if="breadList.length"
                    class="iconfont icon-Unfold-selected1"
                    v-show="index !== breadList.length - 1"
                  ></span>
                </li>
              </ul>
            </div>
            <div :style="boxStyle">
              <el-scrollbar style="height: 100%; overflow-x: hidden">
                <div class="template-list">
                  <template v-if="activeName === 'folder'">
                    <ul class="folder-ul" v-if="directoryList && directoryList.length">
                      <li
                        class="folder-li"
                        v-for="item in directoryList"
                        :key="item.id"
                        @dblclick.stop="goDetail(item)"
                        @click.stop="checkedHref(item)"
                        :class="[checkedData.id == item.id ? 'active' : '']"
                      >
                        <img
                          src="@/assets/image/folder.png"
                          class="folder-img"
                        />
                        <p class="folder-name text-hidden">{{ item.name }}</p>
                        <!-- <p class="folder-len">{{ item.files }}个内容</p> -->
                      </li>
                    </ul>
                    <no-content v-else :text="'暂无搜索结果'"></no-content>
                  </template>
                  <template v-else>
                    <ul class="image-ul" v-if="imageList && imageList.length">
                      <li
                        v-for="item in imageList"
                        :key="item.id"
                        class="image-li"
                        @click.stop="checkedHref(item)"
                        :class="[checkedData.id == item.id ? 'active' : '']"
                      >
                        <div class="image-box">
                          <div class="image-d">
                            <el-image :src="item.cover_url" class="" />
                          </div>
                        </div>
                        <p class="folder-name text-hidden">
                          {{ item.name }}
                        </p>
                      </li>
                    </ul>
                    <no-content v-else :text="'暂无搜索结果'"></no-content>
                  </template>
                </div>
              </el-scrollbar>
            </div>
          </div>
          <Pagination
            v-if="Pagination.total"
            @handleCurrentChange="handleCurrentChange"
            :Pagination="Pagination"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { HomeSetting } from "@/config/axios/new_api";
import mixins from "@/config/mixin/index";
import noContent from "../common/noContent.vue";
export default {
  components: { noContent },
  name: "dialogContent",
  mixins: [mixins],
  props: {
    title: {
      type: String,
      default: "",
    },
    tabNav: {
      type: Array,
      default: () => [],
    },
    tabContent: {
      type: Array,
      default: () => [],
    },
    checkedData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: "",

      directoryList: [],
      imageList: [],
      breadList: [], // 文件夹 面包屑
      directory: {
        dir_id: 0,
        keyword: "", // 搜索关键字
      },
      checked: null,
    };
  },

  created() {
    this.getData();
  },
  mounted() {
    this.activeName = this.tabNav[0].activeName;
  },
  computed: {
    boxStyle() {
      return this.activeName === "folder"
        ? { height: "380px" }
        : { height: "100%" };
    },
  },
  methods: {
    getData() {
      let params = {
        dir_id: this.directory.dir_id,
        keyword: encodeURIComponent(this.directory.keyword), // 搜索关键字
      }
      let data = { ...params, ...this.Pagination };
      HomeSetting.dirList(data).then((res) => {
        this.directoryList = res.data && res.data.data;
        this.Pagination.total = res.data && res.data.pagination.total;
        if (!res.data || !res.data.pagination.total) {
          this.Pagination.total = 0;
          this.Pagination.page = 1;
        }
      });
    },
    getTemplate() {
      // 模板分类
      let data = {
        keyword: encodeURIComponent(this.directory.keyword),
        ...this.Pagination,
        // home_template_class_id: ,
      };
      HomeSetting.templateList(data).then((res) => {
        if (!res.data || res.data.pagination.total) {
          this.imageList = res.data && res.data.data;
          this.Pagination.total = res.data && res.data.pagination.total;
        } else {
          this.Pagination.total = 0;
          this.Pagination.page = 1;
          this.imageList = [];
        }
      });
    },
    handleClick(status = true) {
      // 切换需要 重置
      this.close(!status);
      // this.$emit("getCheckedData", {}, this.activeName);
      if (this.activeName === "folder") {
        this.getData();
      } else if (this.activeName === "image") {
        this.getTemplate();
      }
    },
    checkedHref(item) {
      // 单击选中文件夹 要传递给前面一个调用函数
      this.$emit("getCheckedData", item, this.activeName);
    },
    goDetail(item) {
      if (item === 0) {
        this.directory.dir_id = item;
        this.breadList = [];
      } else {
        if (item.is_empty || item.cover_url) {
          let index = -1;
          for (let i = 0; i < this.breadList.length; i++) {
            if (this.breadList[i].id === item.id) {
              index = i;
            }
          }
          if (index === -1) {
            this.breadList.push(item);
          } else {
            this.breadList.splice(index + 1, this.breadList.length);
          }
          this.directory.dir_id = item.id;
        }
      }
      if (item === 0 || item.is_empty || item.cover_url) {
        this.Pagination.page = 1;
        this.directoryList = [];
        this.getData();
      } else {
        this.$alert("没有文件夹了!", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    handleCurrentChange(val) {
      this.Pagination.page = val;
      if (this.activeName === "folder") {
        this.getData();
      } else if (this.activeName === "image") {
        this.getTemplate();
      }
    },
    close(status = true) {
      this.checked = null;
      if (status) {
        // this.activeName = this.tabNav[0].activeName;
        this.directory = {
          dir_id: 0,
          keyword: "",
        };
        this.breadList = [];
      }
      this.Pagination = {
        page: 1,
        page_size: 10,
        total: 0,
      };
      this.directoryList = [];
    },
    closeDialog() {
      this.close(true);
      this.activeName = this.tabNav[0].activeName;
    },
  },
};
</script>

<style lang="scss">
.dt-content {
  @include wh(700px, 434px);
  border-radius: 8px;
  border: 1px solid #dedede;
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 24px;
    &.folder-ul {
      padding: 0px 24px 24px;
    }
  }
  .template-list li {
    @include wh(120px, 150px);
    text-align: center;
    border-radius: 8px;
    margin-right: 12px;
    cursor: pointer;
    background: #fff;
    transition: all 0.3s;
    &.image-li {
      margin-bottom: 10px;
      .image-d {
        border-radius: 8px;
        @include wh(120px, 120px);
      }
    }
    &.active,
    &:hover {
      &.folder-li {
        background: $hoverColor;
      }
      .image-d {
        background: $hoverColor;
      }
      &.image-li > .dl-image {
        background: $hoverColor;
      }
    }
    &.active {
      p {
        color: $activeColor;
      }
    }
    &.folder-li {
      height: 120px;
      .dl-image {
        height: auto;
      }
      &:hover {
        background: $hoverColor;
      }
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    .dl-image {
      @include wh(120px, 120px);
    }
    &.image-li {
      .dl-image {
        border-radius: 8px;
        transition: all 0.3s;
      }
    }
    img {
      @include wh(100%, 120px);
      // padding: 24px 27px 0 26px;
      object-fit: scale-down;
      &.folder-img {
        @include wh(67px, auto);
        padding: 24px 27px 0 26px;
      }
    }
    &.folder-li:hover,
    &.image-li:hover .image-d {
      background: $hoverColor;
    }

    p {
      line-height: 30px;
      height: 30px;
    }
  }
}
</style>

<style lang="scss" scoped>
.bread {
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  height: 52px;
  line-height: 52px;
  color: #2d2d32;
  ul {
    display: flex;
    padding: 0 50px;
    .purple-active {
      color: #7966fe;
      .iconfont {
        color: #7966fe;
      }
    }
  }
}
</style>
